// ─────────────────────────────────────────────────────────────────────────────
// main.ts – Application Bootstrap
// ─────────────────────────────────────────────────────────────────────────────

import { createApp } from 'vue';
import { createPinia } from 'pinia';

import App    from './App.vue';
import router from './router';
import { i18n } from './i18n';

// Import the auth store early so we can call init() before mounting.
import { useAuthStore } from '@/stores/authStore';
import { entferneAltenDienstArbeiter, istBildschirmPfad } from '@/utils/legacySw';

const app   = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
app.use(i18n);

// Initialise Firebase Auth listener BEFORE mounting so the router guard
// can correctly resolve the auth state on the first navigation.
const authStore = useAuthStore();
authStore.init();

// ─────────────────────────────────────────────────────────────────────────────
// Der Alt-Dienst-Arbeiter der Verwaltungsoberflaeche wird entfernt
// (T-M21.6, REQ-OPS-057 (a)). Begruendung, Grenzen und die Folge fuer OP-132
// stehen im Kopf von `utils/legacySw.ts` und werden hier nicht abgeschrieben.
//
// ⚠ NICHT IN DEN DREI BILDSCHIRM-ANSICHTEN (REQ-OPS-057 (a)/(b)): dort ist der
// Dienst-Arbeiter gewollt. Geprueft wird `location.pathname` und NICHT der
// Router — dieser Bootstrap laeuft vor der ersten Aufloesung des Routers.
// Dieselbe Pruefung steht noch einmal im Modul: hier ist sie lesbar, dort ist
// sie nicht zu umgehen.
//
// Der Aufruf ist bewusst NICHT abgewartet und blockiert den Start nicht; er
// wirft nie, und die Entfernung wirkt ohnehin erst beim naechsten Laden — es
// wird kein Neuladen ausgeloest (REQ-OPS-057 (d)).
// ─────────────────────────────────────────────────────────────────────────────
if (typeof location !== 'undefined' && !istBildschirmPfad(location.pathname)) {
  void entferneAltenDienstArbeiter();
}

app.mount('#app');
